import { $user } from "@/services";
import { getToken, setToken, removeToken } from "@/utils/auth";

const user = {
  state: {
    token: getToken(), // 初始化时直接从工具类获取
    id: "",
    name: null,
    userInfo: null,
    permissions: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER_INFO: (state, userInfo) => {
      state.id = userInfo.id;
      state.name = userInfo.userName;
      state.userInfo = userInfo;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
  },

  actions: {
    // 1. 登录 Action
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        $user
          .login(userInfo)
          .then((res) => {
            if (res.code === 0) {
              commit("SET_TOKEN", res.token);
              commit("SET_USER_INFO", res.info);
              setToken(res.token);
              resolve(res);
            } else {
              reject(new Error(res.msg || "登录失败"));
            }
          })
          .catch((error) => reject(error));
      });
    },

    // 2. 获取用户信息 Action (在页面刷新、路由跳转时调用)
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        // 使用当前的 token 换取用户信息和权限
        let data = { menuApplyCode: 1, userId: state.id };
        $user
          .menuPromise(data)
          .then((res) => {
            if (res.code === 200) {
              commit("SET_PERMISSIONS", res.data.permissions || res.data);
              resolve(res.data);
            } else {
              reject(new Error("获取用户信息失败"));
            }
          })
          .catch((error) => reject(error));
      });
    },

    // 3. 登出 Action
    LogOut({ commit }) {
      return new Promise((resolve) => {
        // 不管后端注销接口成没成功，前端必须清空状态
        commit("SET_TOKEN", "");
        commit("SET_USER_INFO", {});
        commit("SET_PERMISSIONS", []);
        removeToken(); // 移除本地Token
        resolve();
      });
    },
  },
};
export default user;
